import { useMemo } from 'react';
import { useEnterpriseAppsSection } from '../useEnterpriseAppsSection';
import { useSections } from '../useSections';
export function useHomepage() {
  let {
    productId,
    shouldFetchEnterpriseApps = true
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    isEnterpriseAppsSectionLoading,
    isEnterpriseAppsSectionLoadError,
    enterpriseAppsSectionData,
    enterpriseAppsSectionStatus,
    enterpriseAppsSectionDataError
  } = useEnterpriseAppsSection({
    shouldExitEarly: !shouldFetchEnterpriseApps,
    productId
  });
  const shouldFetchApps = enterpriseAppsSectionStatus === 'resolved' || enterpriseAppsSectionStatus === 'rejected';
  const additionalFilters = useMemo(() => {
    return (enterpriseAppsSectionData === null || enterpriseAppsSectionData === void 0 ? void 0 : enterpriseAppsSectionData.apps.map(app => {
      return "addonKey:-".concat(app.addonKey);
    })) || [];
  }, [enterpriseAppsSectionData === null || enterpriseAppsSectionData === void 0 ? void 0 : enterpriseAppsSectionData.apps]);
  const {
    areSectionsLoading,
    isSectionsLoadError,
    sectionsData,
    sectionsDataError
  } = useSections({
    shouldFetchApps,
    additionalFilters,
    productId
  });
  return {
    isEnterpriseAppsSectionLoading,
    isEnterpriseAppsSectionLoadError,
    enterpriseAppsSectionData,
    areSectionsLoading,
    isSectionsLoadError,
    sectionsData,
    enterpriseAppsSectionDataError,
    sectionsDataError
  };
}